<div *ngIf="notifications.length"
  class="position-fix start-column-vertical-right-container padding-top-2 padding-right-2 column-gap-1 notifications-wrapper" 
   [class.notifications-wrapper-m]="mobileDesign">
  <ng-container *ngFor="let n of notifications; index as i">
    <div [style.visibility]="n.hidden ? 'hidden' : 'initial'" class="width-21p875 position-rel aligned-row-container row-gap-0p625 br-0p625 clickable notification-tr">
      <svg class="position-abs width-1p875 height-1p875 close-svg" 
        [class.icon-size]="mobileDesign"
       (click)="n.hidden = true">
        <use [attr.xlink:href]="'/assets/svg/optimized/close.svg#img'"
          [attr.href]="'/assets/svg/optimized/close.svg#img'"></use>
      </svg>
      <div class="width-1p875 mob-height-7p5em mob-width-7p5em height-1p875 {{n.type}}"
        [ngClass]="{'mob-height-7p5em': mobileDesign, 'mob-width-7p5em': mobileDesign}"></div>
       <div class="notification-text-container vertical-container-simple">
        <div class="font-3 bold500"
          [class.mob-font-5em]="mobileDesign">
            {{n.title}}
          </div>
        <div class="font-4 color"
          [class.mob-font-4em]="mobileDesign">
          {{n.message}}
        </div>
      </div>
    </div>
  </ng-container>
</div>
